<template>
  <div class="content">
    <div class="content-left">
      <div class="content-left-caption">
        创建试卷
      </div>
      <div class="content-left-type">
        <!-- <label class="content-left-type-note">试卷分类：</label>
        <el-select v-model="exam.type" placeholder="请选择分类" class="content-left-type-select" size="medium">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              size="medium"
            />
          </el-select> -->
          <label class="content-left-type-note"><span class="content-mustnote">*</span>试卷标题：</label>
          <el-input
            ref="examname"
            v-model="exam.name"
            placeholder="请输入标题"
            class="content-left-title-input"
            size="medium"
            clearable
          />
          <div class="content-left-type-grade">
            试卷总分：
            <label class="content-left-type-grade-value">{{getScore()}}</label>
            分
          </div>
      </div>
      <div class="content-left-type">
          <label class="content-left-type-note"><span class="content-mustnote">*</span>试卷分类：</label>
          <el-input
            ref="examcate"
            v-model="exam.cate"
            placeholder="请输入分类"
            class="content-left-title-input"
            size="medium"
            clearable
          />
      </div>
      <!-- <div class="content-left-title">
        <label class="content-left-title-note">试卷标题：</label>
        <el-input
          v-model="exam.name"
          placeholder="请输入标题"
          class="content-left-title-input"
          size="medium"
          clearable
        />
      </div> -->
      <div class="content-left-abstract">
        <label class="content-left-abstract-note"><span class="content-mustnote">*</span>试卷简介：</label>
        <el-input
            ref="exampaperIntroduction"
            v-model="exam.paperIntroduction"
            placeholder="请输入简介"
            class="content-left-abstract-input"
            :rows="3"
            type="textarea"
            clearable
          />
      </div>
      <div class="content-left-operate">
        <el-checkbox class="content-left-operate-checkbox" v-model="isSelectAll" label="全选" size="large" @change="clickSelectAll"/>
        <div class="spring"></div>
        <button class="content-left-operate-btn" type="primary" plain @click="handleClick(0, 'Xt')">手动选题</button>
        <!-- <button class="content-left-operate-btn" type="primary" plain>排序</button> -->
        <!-- <button class="content-left-operate-btn" type="primary" plain>批量设置分数</button> -->
        <button class="content-left-operate-btn content-left-operate-delete" type="primary" plain @click="deleteItem(-1)">删除试题</button>
        <button class="content-left-operate-btn content-left-operate-preview" type="primary" plain @click="goDetail">预览</button>
      </div>
      <div class="content-left-list">
        <div class="content-left-list-item" v-for="(item, index) in exam.examQuestions" :key="index">
          <el-checkbox class="content-left-list-item-checkbox" v-model="item.checked" label="" size="large" @change="clickSelect(item)"/>
          <div class="content-left-list-item-content" v-show="exam.examQuestions.length>0">
            <div class="content-left-list-item-content-title">
              <label class="content-left-list-item-content-title-order">{{index+1}}/{{exam.examQuestions.length}}</label>
              <label class="content-left-list-item-content-title-type">{{getTypeText(item.type)}}</label>
              <label class="content-left-list-item-content-title-text">{{ item.questionsList}}</label>
              <!-- <input class="content-left-list-item-content-title-grade" v-model="item.score"> -->
              <el-input-number
                size="small"
                @change="setCurrentScore(item)"
                v-model="item.score"/>
              <label class="content-left-list-item-content-title-unit">分</label>
            </div>
            <div class="content-left-list-item-content-option" v-show="item.isOpen && item.examQuestionsOptions.length >0">
              <template v-if="item.type==0" >
                  <el-radio
                  :key="index2"
                  class="content-left-list-item-content-option-radio"
                  v-for="(op, index2) in item.examQuestionsOptions"
                  disabled
                  :label="item.examQuestionsOptions.find(x=>x.isTrue).optionsList"
                  @change="selectAnswer(item, index2)"
                  v-model="op.optionsList"
                  size="large">
                  {{op.optionsList}}
                  </el-radio>
              </template>
              <template v-else-if="item.type==1">
                  <el-checkbox
                  :key="index2"
                  class="content-left-list-item-content-option-radio"
                  v-for="(op, index2) in item.examQuestionsOptions"
                  :label="op.optionsList"
                  @change="checkAnswer(op)"
                  v-model="op.isTrue"
                  size="large"
                  />
              </template>
              <template v-else>
                  <!-- <el-checkbox
                  :key="index2"
                  class="content-left-list-item-content-option-radio"
                  v-for="(op, index2) in item.examQuestionsOptions"
                  :label="op.optionsList"
                  @change="checkAnswer(op)"
                  v-model="op.isTrue"
                  size="large"
                  /> -->
                  <div v-for="(op, index2) in item.examQuestionsOptions" :key="index2"  class="content-left-list-item-content-option-radio">
                    <el-input type="text" v-model="op.keyword" disabled  style="width:30%"/>

                   <span style="width:10%;margin-left:2rem">{{op.marryType==0?'精准匹配':'模糊匹配'}}</span>

                    <el-input-number
                    size="small"
                    v-model="op.questionsScore"
                    :max="item.score"
                    style="margin-left:2rem"
                    placeholder="设置分数"/>
                  </div>
              </template>
            </div>
            <div class="content-left-list-item-content-oprate">
              <label class="content-left-list-item-content-oprate-note" @click="toggleDetail(item)" >{{getOpenState(item.isOpen)}}</label>
              <img class="content-left-list-item-content-oprate-img" :src="getIcon(item.isOpen)" @click="toggleDetail(item)">
              <el-tooltip content="向下移动" placement="bottom" effect="light">
                <img class="content-left-list-item-content-oprate-img" src="../../assets/moveUp.png" @click="clickUp(index)">
              </el-tooltip>
              <el-tooltip content="向上移动" placement="bottom" effect="light">
                <img class="content-left-list-item-content-oprate-img" src="../../assets/moveDown.png" @click="clickDown(index)">
              </el-tooltip>
              <el-tooltip content="删除" placement="bottom" effect="light">
                <img class="content-left-list-item-content-oprate-img" src="../../assets/delete.png" @click="deleteItem(index)">
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="content-left-list-empty" v-show="exam.examQuestions.length<1">
          <img class="content-left-list-empty-img" src="../../assets/exam_empty.png">
          <label class="content-left-list-empty-note">暂无数据</label>
        </div>
      </div>
    </div>
    <div class="content-right">
      <label class="content-right-caption">设置</label>
      <div class="content-right-item">
        <label class="content-right-item-note"><span class="content-mustnote">*</span>答题时长</label>
        <input class="content-right-item-input" ref="examanswerDate" v-model="exam.answerDate">
        <label class="content-right-item-unit">分钟</label>
      </div>
      <div class="content-right-item">
        <label class="content-right-item-note"><span class="content-mustnote">*</span>及格分数</label>
        <input class="content-right-item-input" ref="exampassScore" v-model="exam.passScore">
        <label class="content-right-item-unit">分</label>
      </div>
      <div class="content-right-item">
        <label class="content-right-item-note"><span class="content-mustnote">*</span>开始时间</label>
        <el-date-picker class="content-right-item-input" ref="examstartDate" v-model="exam.startDate" type="date" placeholder="年/月/日" size="small" format="YYYY/MM/DD"
        value-format="YYYY-MM-DD"/>
      </div>
      <div class="content-right-item">
        <label class="content-right-item-note"><span class="content-mustnote">*</span>结束时间</label>
        <el-date-picker class="content-right-item-input" ref="examendDate" v-model="exam.endDate" type="date" placeholder="年/月/日" size="small" format="YYYY/MM/DD"
        value-format="YYYY-MM-DD"/>
      </div>
      <div class="content-right-switch">
        <label class="content-right-switch-note">是否显示分值</label>
        <el-switch
          v-model="exam.isShowScore"
          class="content-right-switch-value"
          active-color="#0747A6"
        />
      </div>
      <div class="content-right-switch">
        <label class="content-right-switch-note">是否允许多次考试</label>
        <el-switch
          v-model="exam.isMore"
          class="content-right-switch-value"
          active-color="#0747A6"
        />
      </div>
      <div class="content-right-score">
        <label class="content-right-score-note">批量设置分数</label>
        <el-input-number class="content-right-score-value" v-model="batchScore" :min="0" :precision='0' :controls="false" size="mini" @blur="changeScore" @keyup.enter="$event.target.blur()" />
      </div>

      <div class="content-right-score">
        <label class="content-right-score-note">考试对象</label>
        <el-button
          type="text"
          @click="QuestionnaireObjShow"
          class="Questionnaire_SetOverall_Global_Set"
        >设置</el-button>
      </div>

      <div class="content-right-score">
        <label class="content-right-score-note">省-市</label>
        <el-select
          style="width: 40%"
          v-model="exam.provinceId"
          filterable
          placeholder="请选择省"
          @change="ProvinceChange"
          size="mini"
        >
          <el-option
            v-for="item in ProvinceList"
            :key="item.id"
            :label="item.areaName"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-select
          style="width: 40%"
          v-model="exam.cityId"
          filterable
          placeholder="请选择市"
          size="mini"
        >
          <el-option
            v-for="item in CityList"
            :key="item.id"
            :label="item.areaName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="spring"></div>
      <div class="content-right-footer">
        <button class="content-right-footer-btn" @click="goBack()">返回列表</button>
        <button class="content-right-footer-btn content-right-footer-sure" @click="save()" v-show="showSaveBtn">保存并提交</button>
      </div>
    </div>
     <QuestionBankList
      ref="QuestionBankListRef"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancelBank"
      @handle-confirm="handleConfirmBank"
    ></QuestionBankList>
    <ExamEditPriview
    ref="examEditPriview"
    :visiblePV="visiblePV"
    @close-dialog="closeDialogPV"
    @handle-cancel="closeDialogPV"
    ></ExamEditPriview>

    <QuestionDataDetailList
      ref="QuestionDataDetailRef"
      v-model:QuestionnaireObjectSetDialogVisible="QuestionnaireObjectSetDialogVisible"
      v-model:parentcode="parentcode"
      title="考试对象设置"
      @handleCancel="handleCancel"
      @handleConfirm="handleConfirm"
    ></QuestionDataDetailList>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import XEUtils from "xe-utils";

import { ExamList } from "@/assets/apiData/Exam/ExamList";
import QuestionBankList from "@comp/YZExam/QuestionBankList.vue";
import {
  GetExamInfoById,
  ModifyExamData,
  AddExamData,
} from "@api/Exam/ApiExam";
import ExamEditPriview from './ExamEditPriview.vue'
import { dateFormat } from "@/util/utils.js";
import { ElMessage, ElMessageBox } from "element-plus";
import QuestionDataDetailList from "../../components/QuestionnaireCenter/QuestionDataDetailList.vue";
import { ProvinceList } from "@/assets/apiData/Province";

export default {
  name: "ExamEdit",
  data() {
    return {
      showSaveBtn:true,
      router: useRouter(),
      exam:{
        id: 0,
        range: 0,
        name:"",
        cate:"",
        paperIntroduction:"暂无简介",
        answerDate:10,
        passScore:"",
        startDate:"",
        endDate:"",
        isShowScore:false,
        isMore:true,
        examQuestions: [],
        examObjects: [],
        provinceId: "",
        cityId: "",
      },
      settingData:{
        limitTime: "",
        startTime: "",
        endTIme: "",
        passGrade:"",
        isShowGrade: true
      },
      // dataList:[
      //   {type:"多选题", code:1, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意", checked:false},{title:"B. 采取可能的应急措施", checked:false},{title:"C.经现场负责人同意", checked:false},{title:"D. 经单位负责人同意", checked:false}]},
      //   {type:"单选题", code:0, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"单选题", code:0, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"单选题", code:0, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"简答题", code:2, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[]},
      // ],
      isSelectAll: false,
      typeList: [{name:"单选",code:0},{name:"多选",code:1},{name:"问答",code:2}],
      dialogVisible: false,
      param:{
        operation:"Add",
        main:{}
      },
      visiblePV: false,
      batchScore: 0,
      QuestionnaireObjectSetDialogVisible: false,
      parentcode:'',
      ProvinceList: [],
      CityList: [],
    }
  },
  components: {
    QuestionBankList,
    ExamEditPriview,
    QuestionDataDetailList
  },
  methods: {
    setCurrentScore : function(item){
      let score = item.score
      item.examQuestionsOptions.forEach(op=>{
        op.questionsScore = score
      })
    },
    numberChange (key,val,maxNum) {
        //转换数字类型
        key = Number(val)
        //重新渲染
        this.$nextTick(()=>{
            //比较输入的值和最大值，返回小的
            let num = Math.min(Number(val),maxNum)
            //输入负值的情况下， = 0（可根据实际需求更该）
            if(num<0) {
                key = 0
            }else {
                //反之
                key = num
            }
        })
    },
    clickSelectAll(val){
      this.exam.examQuestions.forEach(item=>{
        item.checked = val;
      })
    },
    clickSelect(data){

    },
    selectAnswer(item, index){
      item.answer = index;
    },
    checkAnswer(data){
      console.log("checkAnswer==", data);
    },
    getOpenState(isOpen){
      if(isOpen){
        return "收起";
      }

      return "展开";
    },
    getIcon(isOpen){
       if(isOpen){
        return require(`../../assets/arrow-up.png`);
      }
      return require(`../../assets/arrow-down.png`);
    },
    toggleDetail(data){
      data.isOpen = !data.isOpen;
    },
    goBack(){
      this.router.replace({
        name: "考试中心",
        params: {
          from: "ExamEdit",
          isReplace: true,
        }
      });
    },
    doSave(){
      this.goBack();
    },
    getScore(){
      if(this.exam.examQuestions.length == 0) {
        return 0;
      }
      return eval(this.exam.examQuestions.map(x=>x.score).join("+"))
    },
    getTypeText(type){
      return type==0?"单选题":type==1?"多选题":"简答题"
    },
    initParam(){
      var date1 = new Date();
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + 30);
      this.exam = {
        id: 0,
        range: 0,
        name:"",
        cate:"",
        paperIntroduction:"暂无简介",
        answerDate:10,
        passScore:"",
        startDate:dateFormat("YYYY-mm-dd", date1),
        endDate:dateFormat("YYYY-mm-dd", date2),
        isShowScore:false,
        isMore:true,
        examQuestions: [],
        examObjects: [],
        provinceId: "",
        cityId: "",
      },
      this.param={
        operation:"Add",
        main:{}
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancelBank() {
      this.dialogVisible = false;
    },
    getExamQuestion(item) {
      //item 是 题库题目对象(包含题目选项)
      var obj = {
        examId: this.exam.id,
        questionBankListId: item.id,
        score:0,
        isShowScore:false,
        isMore:false,
        isRandom:false,
        type:item.type,
        questionsList:item.questionsList,
        analysis:item.analysis,
        isManyanswers:false,
        examQuestionsOptions: [], //试卷选项
      };
      item.questionBankListOptionses.forEach(x => {
        var option = {
          id: 0,
          examQuestionsId: 0,
          questionBankListOptionsId: x.id,
          questionsScore: 0,
          number: 0,
          isTrue: x.isTure,
          optionsList: x.optionsList,
          keyword: x.keyword,
          marryType: x.marryType,
        };
        obj.examQuestionsOptions.push(option);
      });
      return obj;
    },
    handleConfirmBank(val) {
      let _this = this;
      _this.dialogVisible = false;

      console.info(val);
      // 找出需要删除的
      var deleteItems = _this.exam.examQuestions.filter(s => {
        let item = val.find(x => {
          return x.id == s.questionBankListId
        })
        return !item
      })
      // 找出需要新增的
      var addItems = val.filter(s => {
        let item = _this.exam.examQuestions.find(x => {
          return x.questionBankListId == s.id
        })
        return !item
      })
      if(deleteItems.length > 0) {
        deleteItems.forEach(x => {
          _this.exam.examQuestions.splice(_this.exam.examQuestions.indexOf(t=>t.questionBankListId==x.questionBankListId),1)
        })
      }
      if(addItems.length > 0) {
        addItems.forEach(x => {
          _this.exam.examQuestions.push(_this.getExamQuestion(x))
        })
      }
      //val 是题库题目 (包含题目选项)
      //debugger;
      //需要删除的
      // _this.exam.examQuestions.forEach(ele => {
      //   //debugger
      //   if (!val.find(x => x.id == ele.questionBankListId)) {
      //     _this.exam.examQuestions.splice(
      //       _this.exam.examQuestions.indexOf(ele),
      //       1
      //     );
      //   }
      // });

      // val.forEach(ele => {
      //   if (
      //     !_this.exam.examQuestions.find(x => x.questionBankListId == ele.id)
      //   ) {
      //     //题库题目 转 试卷题目 (包括题目选项)
      //     _this.exam.examQuestions.push(_this.getExamQuestion(ele));
      //   }
      // });

      // debugger;
      console.log(_this.exam.examQuestions)
    },
    savebefore(){
      let { name, cate, paperIntroduction, answerDate, passScore, startDate, endDate, examQuestions } = this.exam;
      if(name == "") {
        this.$message.warning("请填写试卷标题!");
        this.$refs.examname.focus();
        return false;
      }
      if(cate == "") {
        this.$message.warning("请填写试卷分类!");
        this.$refs.examcate.focus();
        return false;
      }
      if(paperIntroduction == "") {
        this.$message.warning("请填写试卷简介!");
        this.$refs.exampaperIntroduction.focus();
        return false;
      }
      if(answerDate == "") {
        this.$message.warning("请设置答题时长!");
        this.$refs.examanswerDate.focus();
        return false;
      }
      if(passScore == "") {
        this.$message.warning("请设置及格分数!");
        this.$refs.exampassScore.focus();
        return false;
      }
      let totalscore = this.getScore();
      if(passScore > totalscore) {
        this.$message.warning("及格分数不可大于试卷总分!");
        this.$refs.exampassScore.focus();
        return false;
      }
      if(startDate == "") {
        this.$message.warning("请设置开始时间!");
        this.$refs.examstartDate.focus();
        return false;
      }
      if(endDate == "") {
        this.$message.warning("请设置结束时间!");
        this.$refs.examendDate.focus();
        return false;
      }
      if(examQuestions.length == 0) {
        this.$message.warning("请设置考试题目!");
        return false;
      }
      return true;
    },
    save() {
      if(!this.savebefore()) {
        return;
      }
      let _this = this;
      if(this.exam.startDate != "") {
        this.exam.startDate = XEUtils.toDateString(this.exam.startDate, "yyyy-MM-dd")
      }
      if(this.exam.endDate != "") {
        this.exam.endDate = XEUtils.toDateString(this.exam.endDate, "yyyy-MM-dd") + " 23:59:59"
      }
      //_this.set()
      if (this.param.operation=='Add') {
        let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"))
        this.exam.creatorName= USER_INFO.UserName
        this.exam.companyId= USER_INFO.CompanyId
        this.showSaveBtn = false
        const loading = this.loading()
        AddExamData(this.exam)
          .then((res) => {
            loading.close();
            // debugger;
            _this.showSaveBtn = true
            _this.$message.success("保存成功!");

            _this.cancel()
          })
          .catch((res) => {
            loading.close();
            _this.showSaveBtn = true
            _this.$message.error(res.message);
          });
      } else {
        this.showSaveBtn = false
        const loading = this.loading()
        ModifyExamData(this.exam)
          .then((res) => {
            loading.close();
            // debugger;
            _this.showSaveBtn = true
            _this.$message.success("保存成功!");

            _this.cancel()
          })
          .catch((res) => {
            loading.close();
            _this.showSaveBtn = true
            _this.$message.error(res.message);
          });
      }
    },
    cancel(){
      localStorage.removeItem("Exam_senddata");
      this.router.replace({
        name: "考试管理",
        params: {
          from: "ExamManagementEdit",
          isReplace: true,
        },
      });
    },
    handleClick(index, type) {
      var _this = this;
      if (type == "Xt") {
        this.dialogVisible = true;
        // debugger

        this.$refs.QuestionBankListRef.loadDataById("", type,this.exam.examQuestions.map(x=>x.questionBankListId));
      } else if (type == "Delete") {
        DeleteQuestionBank(_this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else if (type == "Add") {
        localStorage.setItem(
          "Exam_senddata",
          JSON.stringify({ operation: type, main: _this.DataList[index] })
        );

        this.router.replace({
          name: "试卷中心",
          params: {
            from: "ExamManagement",
            isReplace: true,
          },
        });
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.QuestionBankListRef.loadDataById(id, type);
      }
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "status":
          cellValue = this.statusList.map((x) => x.code == cellValue).name;
          break;
      }
      return cellValue;
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    GetData() {
      const _this = this;
      if(_this.param.operation=='Add')return
      const loading = this.loading()
      try {
        GetExamInfoById(_this.param.main.id).then(function (data) {
          loading.close()
          data.examQuestions.forEach(item=>{
            item.checked = false;
          })
         _this.exam = data
          // 省市回显处理
          _this.ProvinceList.map((x) => {
            if (x.id == _this.exam.provinceId) {
              _this.CityList = JSON.parse(
                JSON.stringify(x.children.filter((o) => o.level == 3))
              );
              _this.CityList.unshift({
                areaName: "-请选择-",
                id: "",
              });
            }
          });
        });
      } catch (e) {
        loading.close()
        console.log(e);
      }
    },
    //点击上移
    clickUp(index){
      if(index == 0){
        return;
      }
      this.swapArray(this.exam.examQuestions, index-1, index);
    },
    //点击下移
    clickDown(index){
      if(index == this.exam.examQuestions.length){
        return;
      }
      this.swapArray(this.exam.examQuestions, index, index+1);
    },
    //数组元素互换位置
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    deleteItem(index){
      if(index >= 0){
        this.exam.examQuestions.splice(index,1);
        return;
      }
      for(let i = this.exam.examQuestions.length-1; i >= 0; i--){
        if(this.exam.examQuestions[i].checked){
          this.exam.examQuestions.splice(i,1)
        }
      }
    },
    goDetail(){
      localStorage.removeItem('ExamEditPriview_ExamResult')
      localStorage.setItem('ExamEditPriview_ExamResult', JSON.stringify(JSON.stringify(this.exam)));
      // this.$router.push({path: "/ExamEditPriview",params: {from: "ExamEdit"}});
      this.visiblePV = true;
      this.$refs.examEditPriview.getData();
    },
    closeDialogPV(){
      this.visiblePV = false;
    },
    changeScore(){
      let that = this
      ElMessageBox.confirm(
      `是否确认将试卷分数批量设置为${that.batchScore}分`,
      "提示",
      {
        cancelButtonClass: "cancelstyle",
        confirmButtonClass: "confirmstyle",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      }
    )
      .then(() => {
        let editAll = false;
        let checkList = that.exam.examQuestions.filter(item=>{return item.checked})
        //  全选、全不选都按全选来修改选择项分数
        if(checkList.length == 0 || checkList.length == that.exam.examQuestions.length){
          editAll = true;
        }
        that.exam.examQuestions.forEach(item=>{
          if(item.checked || editAll){
            item.score = that.batchScore;
          }
        })
        that.batchScore = 0;
      })
      .catch(() => {
        return;
      });
    },
    QuestionnaireObjShow(){
      var id=0
      if (this.param.operation != 'Add')id=this.param.main.id
      this.$refs.QuestionDataDetailRef.loadDefaulData(this.exam.range.toString(),id)
      this.QuestionnaireObjectSetDialogVisible = true;
    },
    handleCancel(){
      this.QuestionnaireObjectSetDialogVisible = false;
    },
    handleConfirm(obj){
      this.QuestionnaireObjectSetDialogVisible = false;

      this.exam.range=obj.range
      this.exam.examObjects=[]
      if(obj.range=="1"||obj.range=="2")
      {
        obj.ids.forEach(x=>{
          var entity={}
          entity.id=0
          entity.companyId=0
          if(obj.range=="1")entity.departmentId=x
          if(obj.range=="2")entity.userId=x

          this.exam.examObjects.push(entity)
        })
      }
    },
    ProvinceChange() {
      this.exam.cityId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.exam.provinceId) {
          this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
  },
  mounted() {
    // this.initParam()
    // var senddata = localStorage.getItem('Exam_senddata')
    // //跳转过来携带的参数
    // let { operation, main } = JSON.parse(senddata);
    // this.param.operation = operation
    // this.param.main = main

    // this.ExamList = ExamList;
    // this.GetData();
  },
  activated(){
    this.initParam()
    var senddata = localStorage.getItem('Exam_senddata')
    //跳转过来携带的参数
    let { operation, main } = JSON.parse(senddata);
    this.param.operation = operation
    this.param.main = main

    this.ExamList = ExamList;
    this.GetData();
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
  },
}
</script>
<style lang="less" scoped>
  .spring{
    flex: 1;
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
  :deep(.el-radio__input.is-checked .el-radio__inner){
    background-color: #0747A6;
    border-color: #0747A6;
  }
  :deep(.el-checkbox__input.is-checked + .el-checkbox__label),
  :deep(.el-radio__input.is-checked + .el-radio__label){
    color: #0747A6;
  };
  .content{
    display: flex;
    flex-direction: row;
    background: #F0F2F5;
    box-sizing: border-box;
    padding: 0;
    margin: 0;

    &-mustnote{
      color: red;
      font-size: 16px;
      padding-right: 4px;
    }

    &-left{
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #FFFFFF;
      box-sizing: border-box;
      height: 100%;
      padding: 10px;
      // overflow-y: scroll;
      margin-right: 8px;

      &-caption{
        font-size: 16px;
        font-weight: 500;
        color: #33404E;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DEE8;
      }
      &-type{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
        }
        &-select{
          width: 125px;
        }
        &-grade{
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          font-size: 20px;
          font-weight: 500;
          color: #262A33;

          &-value{
            font-size: 20px;
            color: #F7971E;
          }
        }
      }
      &-title{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
        }
        &-input{
          flex: 1;
        }
      }
      &-abstract{
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 10px 0;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
        }
        &-input{
          flex: 1;
        }
      }
      &-operate{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;

        &-checkbox{
          font-size: 14px;
          font-weight: 400;
          color: #000000;
        }
        &-btn{
          height: 32px;
          padding: 2px 10px;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 1px solid #0747A6;
          font-size: 14px;
          font-weight: 400;
          color: #0747A6;
          margin-left: 10px;
        }
        &-delete{
          color: #F7971E;
          border-color: #F7971E;
        }
        &-preview{
          color: #fff;
          border-color: #0747A6;
          background: #0747A6;
        }
      }
      &-list{
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;

        &-item{
          width: 100%;
          display: flex;
          flex-direction: row;
          margin: 6px 0;

          &-checkbox{
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          &-content{
            flex: 1;
            display: flex;
            flex-direction: column;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #C9D1D6;
            padding: 10px;

            &-title{
              width: 100%;
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              padding-bottom: 5px;

              &-order{
                font-size: 10px;
                font-weight: 400;
                color: #FFFFFF;
                background: #0747A6;
                border-radius: 2px 2px 2px 2px;
                padding: 0 5px;
                display: flex;
                margin-right: 5px;
                height: 24px;
                line-height: 24px;
              }
              &-type{
                font-size: 10px;
                font-weight: 400;
                color: #0747A6;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #0747A6;
                padding: 0 5px;
                margin-right: 5px;
                height: 24px;
                line-height: 24px;
                box-sizing: border-box;
              }
              &-text{
                flex: 1;
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                margin-right: 5px;
              }
              &-grade{
                width: 40px;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #B8C2C8;
                font-size: 14px;
                font-weight: 400;
                color: #F7971E;
                text-align: center;
                margin-right: 2px;
                height: 24px;
                line-height: 24px;
                box-sizing: border-box;
              }
              &-unit{
                font-size: 12px;
                font-weight: 400;
                color: #24335A;
                height: 24px;
                line-height: 24px;
              }
            }
            &-option{
              display: flex;
              flex-direction: column;

              &-radio{
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                padding: 10px;
              }
            }
            &-oprate{
              width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
              padding-top: 10px;
              cursor: pointer;

              &-note{
                font-size: 12px;
                font-weight: 400;
                color: #24335A;
              }
              &-img{
                width: 16px;
                height: 16px;
                padding: 2px 5px;
              }
            }
          }
        }
        &-empty{
          flex: 1;
          width: 100%;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #C9D1D6;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;

          &-img{
            width: 400px;
            height: 300px;
          }
          &-note{
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            position: relative;
            left: -234px;
            top: 90px;
          }
        }
      }
    }
    &-right{
      flex: 0 0 255px;
      display: flex;
      flex-direction: column;
      background: #FFFFFF;
      box-sizing: border-box;
      height: 100%;
      padding: 10px;
      overflow-y: scroll;

      &-caption{
        font-size: 16px;
        font-weight: 600;
        color: #262A33;
      }
      &-item{
        padding: 5px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-sizing: border-box;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
          flex: 0 0 80px;
        }
        &-input{
          width: 86px;
          background: #FFFFFF;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #B8C2C8;
          margin-right: 10px;
          box-sizing: border-box;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          text-align: center;
        }
        &-unit{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
          flex:0 0 50px;

        }
      }
      &-score{
        padding: 20px 0;
        display: flex;
        flex-direction: row;
        border-top: 1px solid #D8DEE8;
        justify-content: space-between;
        align-items: center;
          &-note{
            font-size: 16px;
            font-weight: 400;
            color: #24335A;
          }
          &-value{
            width: 90px;
          }
      }
      &-switch{
        padding: 20px 0;
        display: flex;
        flex-direction: row;
        border-top: 1px solid #D8DEE8;
        justify-content: space-between;
        align-items: center;

        &-note{
          font-size: 16px;
          font-weight: 400;
          color: #24335A;
        }
        &-value{
          width: 32px;
          height: 16px;
        }
      }
      &-footer{
        width: 100%;
        display: flex;
        justify-content: space-around;

        &-btn{
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 1px solid #707070;
          padding: 8px 15px;
          font-size: 14px;
          font-weight: 400;
          color: #202020;
        }
        &-sure{
          color: #fff;
          border-color: #0747A6;
          background-color: #0747A6;
        }
      }
    }
  }
</style>